import { useMemo } from "react";
import styles from "./Toggle.module.css";

export default function Toggle({ options, value, onChange }) {
  const index = useMemo(
    () => Math.max(0, options.findIndex(o => o.value === value)),
    [options, value]
  );

  return (
    <div
      className={styles.toggleContainer}
      style={{ "--cols": options.length, "--i": index }}
      role="radiogroup"
    >
      <div className={styles.thumb} />
      {options.map((option, i) => (
        <button
          key={i}
          type="button"
          className={`${styles.option} ${i === index ? styles.active : ""}`}
          onClick={() => onChange(option.value)}
          role="radio"
          aria-checked={i === index}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
